import { Dispatch, useEffect, useRef, useState } from "react";
import { Calendar } from "./Cal";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../store/actions";
import moment from "moment";

const DatePicker = ({ dark = false }: { dark?: boolean } = {}) => {
  const date = useSelector((state: any) => state.form.date);

  const [open, setOpen] = useState(false);
  const dispatch: Dispatch<any> = useDispatch();

  const popoverRef: any = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        toggleDatePicker();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popoverRef]);

  const toggleDatePicker = () => {
    setOpen(!open);
  };

  return (
    <div>
      <div
        onClick={() => {
          toggleDatePicker();
        }}
        className={
          dark
            ? "border-white/25 cursor-pointer h-14 bg-white/10 flex flex-col justify-start text-2xl font-extrabold outline-none border-[1px] rounded-[14px] w-auto text-white/40 px-3 focus-within:border-orange-400 transition-colors"
            : "border-[#302D6340] cursor-pointer h-14 bg-white  flex flex-col justify-start text-2xl font-extrabold outline-none border-[1px] rounded-[4px] w-auto text-[#17171720] px-2  focus:border-b-[#EE723A] focus:border-2"
        }
      >
        <label className={dark ? "text-xs md:text-sm text-left font-normal text-white/80" : "text-xs md:text-sm  text-left font-normal text-[#17171780] "}>
          Departure
        </label>
        <div>
          <div className="flex justify-between items-center h-8 ">
            {date.startDate && (
              <div className={dark ? "text-sm font-normal text-white" : "text-sm font-normal text-black"}>
                {moment.utc(date.startDate).format("ddd, MMM DD")}
              </div>
            )}
          </div>
        </div>
      </div>

      {open && (
        <div className="absolute shadow-md z-50" ref={popoverRef}>
          <Calendar
            date={date.startDate ? new Date(date.startDate) : null}
            onChange={(date: any) => {
              const newDate = new Date(date);
              dispatch(
                Actions.setFlightDate({
                  startDate: moment(newDate).format("YYYY-MM-DD"),
                  endDate: null,
                  key: "selection",
                })
              );
              toggleDatePicker();
            }}
            minDate={new Date()}
            maxDate={new Date(2100, 0, 1)}
            dateDisplayFormat="d"
            monthDisplayFormat="MMM yyyy"
            weekStartsOn={1}
            locale={enUS}
          />
        </div>
      )}
    </div>
  );
};

export default DatePicker;
